import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { StringRequiredSchema } from '@/utils';

const UserDetailsSchema = z.object({
  firstName: StringRequiredSchema('Please enter a first name.'),
  lastName: StringRequiredSchema('Please enter a last name.'),
  companyPosition: z.string(),
  positionType: z.number(),
  chargeableRate: z.number(),
  personalQual: z.string(),
  address: z.string(),
  suburb: z.string(),
  state: z.string(),
  postCode: z.string(),
  phoneNumber: z.string(),
  profilePic: z.instanceof(File).optional().or(z.string()),
  signaturePic: z.instanceof(File).optional().or(z.string()),
});

export type UserDetailsForm = z.infer<typeof UserDetailsSchema>;

export const UserDetailsDefaultValues: UserDetailsForm = {
  firstName: '',
  lastName: '',
  companyPosition: '',
  positionType: 0,
  chargeableRate: 0,
  personalQual: '',
  address: '',
  suburb: '',
  state: '',
  postCode: '',
  phoneNumber: '',
  profilePic: '',
  signaturePic: '',
};

export const useUserDetailsForm = () => {
  const form = useForm({
    defaultValues: UserDetailsDefaultValues,
    resolver: zodResolver(UserDetailsSchema),
    reValidateMode: 'onBlur',
    disabled: false,
  });

  return form;
};
